<script>
  import DataTableBlack from "@components/DataTableBlack.svelte";
  import Modal from "@components/Modal.svelte";
  import { Button, InfoBlock, TextInput } from "paxray-components-svelte";
  import AppButton from "../../lib/components/Button.svelte";
  import { fetchWrapper } from "lib/util/fetchWrapper.js";

  export let currentStep, stepsCompleted, idproject, firstOpen;

  let explanationModalOpen = false;
  let anonymizationRules = [];
  const customRulesRow = {
    id: 0,
    name: "Custom Rules",
    description: "User-defined local-opening rules",
    user: [],
    preset: [],
  };

  function normalizeRows(data) {
    const rows = Array.isArray(data)
      ? data
      : Array.isArray(data?.data)
        ? data.data
        : Array.isArray(data?.desktop)
          ? data.desktop
          : Array.isArray(data?.webapp)
            ? data.webapp
            : [];

    if (!rows.length) return [{ ...customRulesRow }];

    return rows.map((row) => ({
      ...row,
      user: Array.isArray(row.user) ? row.user : [],
      preset: Array.isArray(row.preset) ? row.preset : [],
    }));
  }

  fetchWrapper(`/api/damprojects/getUserLimitations/Whitelist`)
    .then((response) => response.json())
    .then((data) => {
      anonymizationRules = normalizeRows(data);
    });

  let submitModalOpen = false;

  let currentRule = {};
  let currentlistid = 0;
  let editId = -1;
  let currentDetails = -1;
  let tablePagination = { page: 1, pageSize: 10 };

  let newItemModalOpen = false;
  let showHowto = false;
  let howtoStep = 0;

  const howtoSteps = [
    {
      image: "/img/userinput/local/screen1.png",
      text: "Open the app or website as usual",
    },
    {
      image: "/img/userinput/local/screen2.png",
      text: "Find the file name of the app or the address of the website as in the blacklist steps",
    },
    {
      image: "/img/userinput/local/screen3.png",
      text: "Copy the window title as example and pick a keyword from it, e.g. Invoice",
    },
  ];

  $: isLastHowtoStep = howtoStep === howtoSteps.length - 1;

  function openHowto() {
    howtoStep = 0;
    showHowto = true;
  }

  function nextHowtoStep() {
    if (isLastHowtoStep) showHowto = false;
    else howtoStep += 1;
  }

  function previousHowtoStep() {
    if (howtoStep === 0) showHowto = false;
    else howtoStep -= 1;
  }

  function addToRules(id) {
    newItemModalOpen = true;
    currentlistid = id;
    editId = -1;
    showHowto = false;
    currentRule = {
      limitationPresetId: anonymizationRules[id]["id"],
      editable: true,
      id: anonymizationRules[id].user.length,
      name: "",
      appname: "",
      search: "",
      replace: "",
    };
  }

  let appnameerror = false;
  let searcherror = false;
  let nameerror = false;

  function saveNewRule() {
    appnameerror = false;
    searcherror = false;
    nameerror = false;
    if (!currentRule.name) nameerror = true;
    if (!currentRule.appname) appnameerror = true;
    if (!currentRule.search) searcherror = true;
    if (appnameerror || nameerror || searcherror) return;

    currentRule.reason = currentRule.reason || "";

    if (editId == -1)
      anonymizationRules[currentlistid]["user"].push(currentRule);
    else anonymizationRules[currentlistid]["user"][editId] = currentRule;

    anonymizationRules = anonymizationRules;
    newItemModalOpen = false;
  }

  function editUserRule(id) {
    editId = id;
    showHowto = false;
    currentRule = anonymizationRules[currentlistid]["user"][editId];
    newItemModalOpen = true;
  }

  function deleteFromRules(list, id) {
    list.splice(id, 1);
    let indexcounter = 0;
    list.forEach((element) => {
      element.id = indexcounter;
      indexcounter++;
    });
    list = list;
    anonymizationRules = anonymizationRules;
  }

  function submitWhitelist() {
    fetchWrapper(`/api/damprojects/saveUserLimitations/${idproject}/white`, {
      method: "POST",
      body: JSON.stringify(anonymizationRules),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status == "success") {
          currentStep = 4;
          stepsCompleted = true;
          submitModalOpen = false;
        }
      });
  }

  $: indexedAnonymizationRules = anonymizationRules.map((row, sourceIndex) => ({
    ...row,
    sourceIndex,
  }));
</script>

<Modal
  bind:open={submitModalOpen}
  modalHeading="Submit Entries"
  primaryButtonText="Submit Local-Opening Rules"
  secondaryButtonText="Cancel"
  secondaryButtonAction={() => (submitModalOpen = false)}
  primaryButtonAction={submitWhitelist}
  on:close={() => {
    submitModalOpen = false;
  }}
  actions
  autowidth
>
  <p>Do you want to submit your entries?</p>
  <p>This is a permanent action and cannot be undone.</p>
</Modal>

<Modal
  open={firstOpen || explanationModalOpen}
  modalHeading="First Steps"
  primaryButtonText="Okay"
  preventCloseOnClickOutside
  noSecondaryButton
  primaryButtonAction={() => {
    explanationModalOpen = false;
    firstOpen = false;
  }}
  on:close={() => {
    explanationModalOpen = false;
    firstOpen = false;
  }}
  actions
>
  <h5>In this example we show you how to add Excel orders to the whitelist</h5>
  <br /><br /><br />
  <video style="width:100%" controls>
    <track kind="captions" /><track />
    <source src="/img/userinput/local/explanation.mp4" type="video/mp4" />
    Your browser does not support the video tag.
  </video>
</Modal>

<!-- <div class="information_fields">
  <div class="information_field_top">
    Here, you can ensure capturing of relevant applications by defining specific
    whitelist rules.
    <Help20
      style="float:right; cursor:pointer; color:#FF5F1F"
      on:click={() => {
        explanationModalOpen = true;
      }}
    />
  </div>
  <div class="information_field_bottom">
    You will find lists of pre-defined whitelist rules. You can add more rules
    quickly with a single mouse click. To view the whitelist rules, click on the
    arrow to expand the list.
    <br />
    <br />
    Click on the respective <span>+</span> to add your own rules and follow the
    displayed introductions.
    <br />
    <br />
    Submit your input by clicking on <span>submit</span> in the bottom-right corner
    to proceed to the next step.
  </div>
</div> -->
<DataTableBlack
  expandable
  headers={[
    { key: "name", value: "Name" },
    { key: "description", value: "Description" },
    { key: "id", value: "Entries" },
    { key: "edit", value: "Actions" },
  ]}
  rows={indexedAnonymizationRules}
  bind:page={tablePagination.page}
  bind:pageSize={tablePagination.pageSize}
  totalItems={indexedAnonymizationRules.length}
  pageSizes={[10, 25, 50, 100]}
  showNewButton={false}
  showToolbar={false}
>
  <svelte:fragment slot="cell" let:cell let:row>
    {#if cell.key == "edit"}
      <div class="action_cell">
        <AppButton
          variant="secondary"
          size="sm"
          text="Add Rule"
          on:click={() => addToRules(row.sourceIndex)}
        />
      </div>
    {:else if cell.key == "id"}
      {(row.preset || []).length + (row.user || []).length}
    {:else}
      {cell.value}
    {/if}
  </svelte:fragment>
  <svelte:fragment slot="expanded-row" let:row>
    <DataTableBlack
      headers={[
        { key: "name", value: "Name" },
        { key: "appname", value: "Application" },
        { key: "search", value: "Example" },
        { key: "replace", value: "Keyword" },
        { key: "editable", value: "Actions" },
      ]}
      rows={(row.user || []).concat(row.preset || [])}
      showToolbar={false}
      showPagination={false}
    >
      <svelte:fragment slot="cell" let:cell let:row={innerrow}>
        {#if cell.key == "editable" && cell.value}
          <div class="action_cell">
            <AppButton
              variant="secondary"
              size="sm"
              text="Edit"
              on:click={() => {
                editUserRule(innerrow.id);
              }}
            />
            <AppButton
              variant="secondary"
              size="sm"
              text="Delete"
              on:click={() => {
                deleteFromRules(row.user, innerrow.id);
              }}
            />
          </div>
        {:else}
          {cell.value || ""}
        {/if}
      </svelte:fragment>
    </DataTableBlack>
  </svelte:fragment>
</DataTableBlack>

<div class="button_wrapper" data-guide="restrictions-submit">
  <div></div>
  <AppButton
    variant="secondary"
    text="Submit Local-Opening Rules"
    on:click={() => (submitModalOpen = true)}
  />
</div>

<Modal
  bind:open={newItemModalOpen}
  modalHeading={showHowto ? "How to find the details" : "Add Local-Opening Rule"}
  preventCloseOnClickOutside
  noSecondaryButton
  primaryButtonText={showHowto ? (isLastHowtoStep ? "Got it" : "Next") : "Save"}
  primaryButtonAction={showHowto ? nextHowtoStep : saveNewRule}
  primaryButtonVariant="secondary"
  on:close={() => (newItemModalOpen = false)}
  width="auto"
  actions
  xxl
>
  {#if showHowto}
    <div class="howto">
      <img
        class="howto_image"
        src={howtoSteps[howtoStep].image}
        alt={howtoSteps[howtoStep].text}
      />
      <div class="howto_text">
        <p class="howto_step">Step {howtoStep + 1} of {howtoSteps.length}</p>
        <p>{howtoSteps[howtoStep].text}</p>
      </div>
    </div>
  {:else}
    <div class="local_opening_rule_modal">
      <InfoBlock
        type="info"
        heading="Which window?"
        message="Matching windows will be treated as work relevant in all future data collection. Enter the app and an example of the window title."
        showClose={false}
      />

      <div class="input_wrapper">
        <TextInput
          invalid={nameerror && !currentRule.name}
          invalidText="Please specify a name for this rule"
          bind:value={currentRule.name}
          labelText="Name"
          placeholder="Enter name for rule, e.g. Word Invoices"
        />
        <div class="rule_input_row">
          <div class="rule_input_field">
            <TextInput
              invalid={appnameerror && !currentRule.appname}
              invalidText="Please specify a technical name or URL"
              bind:value={currentRule.appname}
              labelText="Application Name"
              placeholder="Enter technical app name or website URL applicable, e.g. winword"
            />
          </div>
          <div class="howto_button">
            <Button kind="secondary" on:click={openHowto}>
              How do I find these details?
            </Button>
          </div>
        </div>
        <TextInput
          invalid={searcherror && !currentRule.search}
          invalidText="Please provide an example"
          bind:value={currentRule.search}
          labelText="Example"
          placeholder="Enter an example for the window title to include, e.g. Invoice 1234.docx"
        />
        <TextInput
          bind:value={currentRule.replace}
          labelText="Keyword"
          placeholder="Enter a possible keyword that should trigger this rule, e.g. Invoice"
        />
      </div>
    </div>
  {/if}
  <div slot="left-buttons">
    {#if showHowto}
      <AppButton
        variant="secondary"
        text={howtoStep === 0 ? "Back to form" : "Back"}
        on:click={previousHowtoStep}
      />
    {:else}
      <AppButton
        variant="secondary"
        text="Cancel"
        on:click={() => (newItemModalOpen = false)}
      />
    {/if}
  </div>
</Modal>

<style>
  .button_wrapper {
    display: flex;
    justify-content: space-between;
    gap: 1rem;
  }

  :global(.bx--data-table th:last-child),
  :global(.bx--data-table td:last-child) {
    padding-right: 1rem;
    text-align: right;
  }

  :global(.bx--data-table th:last-child .bx--table-header-label) {
    display: flex;
    justify-content: flex-end;
  }

  :global(.bx--data-table td:last-child .button-secondary) {
    display: flex;
  }

  .action_cell {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
  }

  .local_opening_rule_modal > :global(* + *) {
    margin-top: var(--control-gap);
  }

  .input_wrapper {
    display: flex;
    flex-direction: column;
    background-color: var(--pax-white);
    gap: var(--control-gap);
  }

  .rule_input_row {
    display: flex;
    align-items: flex-start;
    gap: var(--control-gap);
  }

  .rule_input_field {
    flex: 1;
    min-width: 0;
  }

  /* Aligns the button with the input, below the field label. */
  .howto_button {
    margin-top: 1.5rem;
  }

  .howto {
    display: flex;
    flex-direction: column;
    gap: var(--control-gap);
  }

  .howto_image {
    align-self: center;
    width: auto;
    max-width: 100%;
    /* Modal is capped at 84% height, 18rem covers header, step text and footer. */
    max-height: calc(84vh - 18rem);
    border: 1px solid var(--pax-black-inactive);
    border-radius: 0.5rem;
  }

  .howto_text {
    text-align: center;
  }

  .howto_text p {
    margin: 0;
  }

  .howto_step {
    font-weight: 600;
  }
</style>
